import { ScheduleActivityBase } from './base/schedule-activity-base';

export class ScheduleActivity extends ScheduleActivityBase { }